import { render } from "./ColorSelector.vue?vue&type=template&id=007fb076&ts=true"
import script from "./ColorSelector.vue?vue&type=script&lang=ts"
export * from "./ColorSelector.vue?vue&type=script&lang=ts"

import "./ColorSelector.vue?vue&type=style&index=0&id=007fb076&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__